import { useState, useEffect } from 'react';
import { constructHeadline } from '../service/CreatePromotionService';

export const usePromotionPreview = ({
  data,
  promotionData,
  flipValue,
  selectedConjunction,
  disableDRAFTBtn,
  disableUPDATEBtn,
  selectedStores,
}) => {
  const [headline, setHeadline] = useState('[Please Select an HEADLINE]');
  const [disclaimerData, setDisclaimerData] = useState(null);
  const [notes, setNotes] = useState(null);

  // Dynamically generate the headline based on the promotion data
  useEffect(() => {
    setHeadline(constructHeadline(data, flipValue, selectedConjunction));
    setDisclaimerData(data?.disclaimer || {});
    setNotes(data?.notes || '');
  }, [data, flipValue, selectedConjunction]);

  // Button disabled conditions
  const isHeadlineEmpty = (headline) =>
    headline === null || headline.length === 0 || headline === '[Please Select an HEADLINE]';

  // Check if any offer checkbox is checked but no actual offer data has been entered
  const hasIncompleteOffers = (promotionData) => {
    const discountOffer = promotionData?.discount_offer;
    const financeOffers = promotionData?.finance_offer;

    // Discount offer checkbox is checked but offer object is empty (no headline selected)
    if (
      discountOffer !== undefined &&
      discountOffer !== null &&
      Object.keys(discountOffer).length === 0
    ) {
      return true;
    }

    // Finance offer checkbox is checked but any offer object is empty (no headline selected)
    if (Array.isArray(financeOffers) && financeOffers.length > 0) {
      if (financeOffers.some((offer) => !offer || Object.keys(offer).length === 0)) {
        return true;
      }
    }

    return false;
  };

  const isButtonDisabled = (buttonType) => {
    const offersIncomplete = hasIncompleteOffers(promotionData);

    switch (buttonType) {
      case 'create':
        return (
          selectedStores.length === 0 ||
          !promotionData?.start_date ||
          !promotionData?.end_date ||
          offersIncomplete
        );
      case 'update':
        return disableUPDATEBtn || isHeadlineEmpty(headline) || offersIncomplete;
      case 'publish':
        return isHeadlineEmpty(headline) || offersIncomplete;
      case 'draft':
        return disableDRAFTBtn || isHeadlineEmpty(headline) || offersIncomplete;
      default:
        return true;
    }
  };

  return {
    headline,
    disclaimerData,
    notes,
    isButtonDisabled,
  };
};
